import React, { Component } from 'react';
import { connect } from 'react-redux';
import DatePicker from 'react-datepicker';

import { START_DATE, END_DATE } from '../../actions/index';
import moment from 'moment';

class DateRangeFilterMoment extends Component {
	handleChangeStart( date ) {
		let startDate = date.target.value;
		if( startDate !== '' ) {
			startDate = moment( startDate );
		}
		this.props.dispatch( {
			                     type: START_DATE, payload: startDate
		                     } );
	}

	handleChangeEnd( date ) {
		let endDate = date.target.value;
		if( endDate !== '' ) {
			endDate = moment( endDate );
		}
		this.props.dispatch( {
			                     type: START_DATE, payload: endDate
		                     } );
	}

	render() {
		const formattedStart = (this.props.dateRange.startDate !== '' ) ? moment( this.props.dateRange.startDate ).format( 'YYYY-MM-DD' ) : null;
		const formattedEnd = (this.props.dateRange.endDate !== '' ) ? moment( this.props.dateRange.endDate ).format( 'YYYY-MM-DD' ) : null;
		return (<div id="" className="form-group-date-range form-group">
				<input type="date"
				       className="search-input"
				       value={ formattedStart }
				       onChange={ this.handleChangeStart.bind( this ) }
				       placeholder="mm/dd/yyyy"
				       name="date_from"
				       data-minlength="3"
				/>
				<span className={ 'date-spacer' }>-</span>
				<input type="date"
				       className="search-input"
				       value={ formattedEnd }
				       onChange={ this.handleChangeEnd.bind( this ) }
				       placeholder="mm/dd/yyyy"
				       name="date_to"
				       data-minlength="3"
				/>

			</div>
		);
	}
}

function mapStateToProps( { dateRange } ) {
	return { dateRange };
}

export default connect( mapStateToProps )( DateRangeFilterMoment );